import styled from 'styled-components';

import colors from '../../styles/colors';

export const Container = styled.div`
  p {
    max-width: 387px;
    font-size: 18px;
    line-height: 1.5em;
    margin-bottom: 40px;
  }
  button {
    margin: 40px 0;
  }
  a {
    text-align: center;
    text-transform: uppercase;
    color: ${colors.primary};
    font-size: 16px;
  }
`;
